import { createFileRoute, useNavigate } from '@tanstack/react-router';
import type { Row } from '@tanstack/react-table';
import { zodValidator } from '@tanstack/zod-adapter';
import type { ChangeEvent } from 'react';
import ActionButton from '@/components/Button/ActionButton';
import { DataTable, DataTablePagination } from '@/components/DataTable';
import { FillScreen, HStack, ListToolbar } from '@/components/Layout';
import SearchInput from '@/components/SearchInput';
import { useDebouncedCallback } from '@/hooks/useDebouncedCallback';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import InventoryTabs from './-components/tab/inventoryTabs';
import { useInventoryTabs } from './-components/tab/inventoryTabs';
import { SearchSchema } from './-constants';
import { useTable } from './-hooks/useTable';
import type { LicenseTableRow } from './-types';
export const Route = createFileRoute('/_staff/licenses/_list/inventory/')({
  component: List,
  validateSearch: zodValidator(SearchSchema)
});
function List() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.licenses'
  });
  useDocumentTitle(t('inventory.pageTitle'));
  const navigate = useNavigate({
    from: '/licenses/inventory'
  });
  const search = Route.useSearch();
  const {
    table,
    displayState,
    counts
  } = useTable();
  const inventoryTabsProps = useInventoryTabs();

  // TODO: ライセンスのCSV出力機能を作成する
  //  const { mutate: exportLicensesCsv, isPending } = useLicensesExport({
  //    category: search.category,
  //    freeText: search.freeText,
  //  });

  const handleFilterInput = useDebouncedCallback((e: ChangeEvent<HTMLInputElement>) => navigate({
    search: prev => ({
      ...prev,
      pageIndex: 0,
      freeText: e.target.value
    })
  }), [navigate]);
  const handleRowClick = (row: Row<LicenseTableRow>) => {
    const data = row.original;
    if (row.getCanExpand()) {
      row.toggleExpanded();
      return;
    }
    const licenseId = data.softwareLicense.license?.id;
    if (!licenseId) return;
    navigate({
      to: '/licenses/$id',
      params: {
        id: licenseId
      }
    });
  };
  return <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <HStack className="gap-2 items-center">
        <InventoryTabs {...inventoryTabsProps} />
        <span className="ml-auto">
          <ActionButton icon="PlusIcon" className="bg-primary-fill" onClick={() => navigate({
          to: '/licenses/add'
        })}>
            {t('inventory.addLicense')}
          </ActionButton>
        </span>
      </HStack>
      <ListToolbar className="rounded bg-background p-2">
        {/* ライセンス種別のフィルタ作ってもいいかも */}
        <SearchInput className="h-8 w-56 shrink-0" placeholder={t('inventory.filterPlaceholder')} defaultValue={search.freeText} onChange={handleFilterInput} />
        {/* <ActionButton
          icon="Download"
          variant="ghost"
          iconColor="primary"
          className="ml-auto shrink-0"
          onClick={() => exportLicensesCsv()}
          isLoading={isPending}
         >
          {tCommon("action.export")}
         </ActionButton> */}
      </ListToolbar>
      <div className="overflow-auto flex-1 min-h-0">
        <DataTable table={table} displayState={displayState} onRowClick={handleRowClick} isHoverable />
      </div>
      <DataTablePagination table={table} totalCount={counts} />
    </FillScreen>;
}